import isMobile from "../../helpers/isMobile";

interface Position {
	x: number;
	y: number;
}

function getClickPosition(e: React.MouseEvent, thinkId: string, boxId: string) {
	const theThing = document.getElementById(thinkId) as HTMLElement;
	const box = document.getElementById(boxId) as HTMLElement;

	if (isRelation(e)) {
		const parentPosition = getPosition(e.currentTarget as HTMLElement);
		const xPosition = e.clientX - parentPosition.x - 85;
		const yPosition = e.clientY - parentPosition.y + 30;

		theThing.style.left = `${xPosition}px`;
		theThing.style.top = `${yPosition}px`;
		const thinkBounding = theThing.getBoundingClientRect();
		const boxBounding = box.getBoundingClientRect();

		if (thinkBounding.x <= boxBounding.x) {
			theThing.style.left = `${
				Number(theThing.style.left.replace("px", "")) +
				(boxBounding.x - thinkBounding.x)
			}px`;
		}
		if (
			thinkBounding.x + thinkBounding.width >=
			boxBounding.x + boxBounding.width
		) {
			if (!isMobile()) {
				theThing.style.left = "unset";
				theThing.style.right = "-80px";
			} else {
				theThing.style.left = "unset";
				theThing.style.right = "50%";
				theThing.style.transform = "translateX(50%)";
			}
		}
		if (boxBounding.width < 400) {
			theThing.style.width = "calc(100% - 5px)";
		}
	} else {
		theThing.style.zIndex = "-2";
	}
}

function getPosition(el: HTMLElement | null): Position {
	let xPos = 0;
	let yPos = 0;

	while (el) {
		if (el.tagName === "BODY") {
			const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
			const yScroll = el.scrollTop || document.documentElement.scrollTop;

			xPos += el.offsetLeft - xScroll + el.clientLeft;
			yPos += el.offsetTop - yScroll + el.clientTop;
		} else {
			xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
			yPos += el.offsetTop - el.scrollTop + el.clientTop;
		}

		el = el.offsetParent as HTMLElement | null;
	}

	return {
		x: xPos,
		y: yPos,
	};
}

interface LinkDetails {
	linkHash?: string;
	relationHash?: string;
}

const findAttributes = (target: HTMLElement): LinkDetails => {
	const { attributes } = target;
	const dataLinkHash = attributes.getNamedItem("data-link-hash");
	const dataRelationHash = attributes.getNamedItem("data-relation-hash");
	if (target.tagName === "SECTION") {
		return {};
	}

	if (!dataLinkHash || !dataRelationHash) {
		return findAttributes(target.parentNode as HTMLElement);
	}

	return { linkHash: dataLinkHash.value, relationHash: dataRelationHash.value };
};

export const getSelectedLinkDetails = (
	target: HTMLElement | null,
): LinkDetails => {
	if (!target) {
		return {};
	}

	return findAttributes(target);
};

const onMouseUp = (e: React.MouseEvent, thinkId: string, boxId: string) => {
	getClickPosition(e, thinkId, boxId);
};

export const isRelation = (e: React.MouseEvent | null) => {
	return (
		e?.target &&
		((e.target as HTMLElement).className.includes("relations") ||
			((e.target as HTMLElement).parentNode as HTMLElement)?.className.includes(
				"relations",
			))
	);
};

export { onMouseUp };
